import { CopyToClipboard } from '@cloudscape-design/components';
import React from 'react';

interface CopyProps {
  value?: string;
  text?: string;
}
const Copy: React.FC<CopyProps> = ({
  value = "",
  text = "ID Copiado"
}) => {

  return (
    <CopyToClipboard
      textToCopy={String(value)}
      variant='icon'
      popoverRenderWithPortal={true}
      copySuccessText={text}
      copyErrorText={'Error en la copia'}
    />
  );
};

export default Copy;